import { connect } from 'react-redux'
import SearchMessageSidebarComponent from './component'

const mapStateToProps = state => ({

})

const mapDispatchToProps = dispatch => ({
    
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SearchMessageSidebarComponent)